import React from 'react'
import { component_tool, utils_tool } from '@/tool'
const { WizComponent, WizRadio, WizInput, WizRow, WizCol, WizTooltip } = component_tool;
const { checkStrLength } = utils_tool
export default class QsRadio extends WizComponent {
    render() {
        const { preview, answer, options, otherAnswer, allowOther, otherDescribe } = this.props
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px'
        };
        const radioArr = options.map(val => <WizRadio key={val.id} style={radioStyle} value={val.id} checked={val.id === Number(answer)} disabled={!preview ? true : false}>{val.content} </WizRadio>)
        const CustomInput = () => {
            let inputProps = {}
            let checkboxProps = {}
            if (!preview) {
                inputProps = { ...inputProps, value: otherAnswer, disabled: true }
                checkboxProps = { ...checkboxProps, checked: true, disabled: true }
            }
            return (
                <WizRow type="flex" align="middle">
                    <WizCol span={8}>
                        <WizRadio {...inputProps}>
                            <WizTooltip title={otherDescribe}>{checkStrLength(otherDescribe, 10)}</WizTooltip>
                        </WizRadio>
                    </WizCol>
                    <WizCol pull={2} span={10}><WizInput {...inputProps} /></WizCol>
                </WizRow>
            )
        }

        return (
            <>
                <WizRadio.Group >
                    {radioArr}
                </WizRadio.Group>
                {allowOther ? <CustomInput /> : null}
            </>
        )
    }
} 